import { useState } from 'react';
import useApi from './useApi.hook';

export function useUserDetails() {
	const [userDetails, setUserDetails] = useState(null);
	const [loadingUser, setLoadingUser] = useState(false);
	const api = useApi();

	const fetchUserDetails = async (userId) => {
		setLoadingUser(true);
		try {
			const { data } = await api.get(`/users/${userId}`);
			setUserDetails(data);
		} catch {
			setUserDetails(null);
		} finally {
			setLoadingUser(false);
		}
	};

	return { userDetails, setUserDetails, loadingUser, fetchUserDetails };
}